import { lazy, Suspense, type ReactNode } from 'react';
import type { RouteObject } from 'react-router-dom';
import PageLoader from '@/components/base/PageLoader';
import NotFound from '../pages/NotFound';

/* ─── Public routes (lazy loaded) ─── */
const Home = lazy(() => import('../pages/home/page'));
const BlogPost = lazy(() => import('../pages/blog-post/page'));
const Category = lazy(() => import('../pages/category/page'));

/* ─── Admin routes (lazy loaded, heavier chunks) ─── */
const AdminLogin = lazy(() => import('../pages/admin/login/page'));
const AdminDashboard = lazy(() => import('../pages/admin/dashboard/page'));
const AdminPosts = lazy(() => import('../pages/admin/posts/page'));
const AdminPostsNew = lazy(() => import('../pages/admin/posts-new/page'));
const AdminPostsEdit = lazy(() => import('../pages/admin/posts-edit/page'));
const AdminCategories = lazy(() => import('../pages/admin/categories/page'));
const AdminChangePassword = lazy(() => import('../pages/admin/change-password/page'));

function LazyWrap({ children }: { children: ReactNode }) {
  return <Suspense fallback={<PageLoader />}>{children}</Suspense>;
}

const routes: RouteObject[] = [
  { path: '/', element: <LazyWrap><Home /></LazyWrap> },
  { path: '/blog', element: <LazyWrap><Home /></LazyWrap> },
  { path: '/blog/:slug', element: <LazyWrap><BlogPost /></LazyWrap> },
  { path: '/categoria/:slug', element: <LazyWrap><Category /></LazyWrap> },
  { path: '/admin/login', element: <LazyWrap><AdminLogin /></LazyWrap> },
  { path: '/admin', element: <LazyWrap><AdminDashboard /></LazyWrap> },
  { path: '/admin/posts', element: <LazyWrap><AdminPosts /></LazyWrap> },
  { path: '/admin/posts/novo', element: <LazyWrap><AdminPostsNew /></LazyWrap> },
  { path: '/admin/posts/editar/:id', element: <LazyWrap><AdminPostsEdit /></LazyWrap> },
  { path: '/admin/categorias', element: <LazyWrap><AdminCategories /></LazyWrap> },
  { path: '/admin/alterar-senha', element: <LazyWrap><AdminChangePassword /></LazyWrap> },
  { path: '*', element: <LazyWrap><NotFound /></LazyWrap> },
];

export default routes;

/* ─── Route chunk imports for intelligent prefetch ─── */
export const routePrefetchMap: Record<string, () => Promise<unknown>> = {
  '/blog/:slug': () => import('../pages/blog-post/page'),
  '/categoria/:slug': () => import('../pages/category/page'),
};
